import { createTheme } from '@mui/material/styles'
import { lightPalette } from './tokens'

export const appTheme = createTheme({
  palette: lightPalette,
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#f0642394',
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#F06423',
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#F06423',
          '.MuiCircularProgress-circle': {
            stroke: '#F06423',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          '&.MuiTypography-colorSecondary': {
            color: '#f50057 !important',
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          lineHeight: '1 !important',
          fontSize: '0.7rem !important',
          '.MuiListItemIcon-root': {
            minWidth: '1.8rem !important',
          },
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          borderColor: 'lightgray !important',

          '& .MuiButtonGroup-firstButton': {
            borderColor: 'lightgray !important',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '0.8125rem',
          textTransform: 'none',

          '&.MuiButton-contained': {
            fontSize: '0.8125rem',
          },
          '&.MuiButton-outlined': {
            textTransform: 'none',
            '&:hover': {
              color: '#FFFFFF',
              backgroundColor: 'var(--color-primary-dark)',
            },
            color: 'var(--color-primary-dark)',
            border: 'var(--color-primary-dark) solid .1rem',
            padding: '0.3125rem 1rem',
          },
          '&.MuiButton-sizeSmall': {
            fontSize: '0.8125rem',
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&.MuiAccordion-root': {
            border: 'none',
            boxShadow: 'none',
            paddingTop: '0px',
            backgroundColor: 'var(--color-background-subtle)',
            '&.MuiAccordion-root.Mui-expanded': {
              margin: '0px !important',
            },
            '&:not(:last-child)': {
              borderBottom: 0,
            },
            '&:before': {
              display: 'none',
            },
            '&$expanded': {
              margin: 'auto',
            },
          },
          '.MuiSvgIcon-root': {
            fontSize: '1.25rem',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          '&.MuiAccordionSummary-root': {
            marginBottom: 0,
            flexDirection: 'row-reverse',
            justifyContent: 'flex-start',
            alignItems: 'center',
            minHeight: 4,
            padding: '0.1rem 1rem 0px 0px',
          },
          '.MuiAccordionSummary-content': {
            minHeight: 5,
            margin: '0.1rem 0rem 0rem 0rem !important',
            padding: '0rem',
          },
          '.Mui-expanded': {
            margin: '1px 0 !important',
          },
          '.MuiAccordionSummary-expandIconWrapper': {
            transform: 'rotate(270deg)',
          },
          '.MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(0deg)',
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          '&.MuiAccordionDetails-root': {
            padding: '0px 8px 0px 8px !important',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.MuiRadio-root': {
            color: 'var(--color-text-secondary)',
            cursor: 'pointer',
            fontSize: '0.7rem !important',
            padding: '0.25rem 0.4rem !important',
            '& svg': {
              width: '0.7rem !important',
              height: '0.7rem !important',
            },
            '&.Mui-checked': {
              color: 'var(--color-secondary)',
            },
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          // color: '#f16522',
          width: '80%',
          height: '2px',
          padding: '13px 0',
          fontSize: '0.7rem',
          marginBottom: '35px',

          '& .MuiSlider-rail': {
            backgroundColor: 'var(--color-border-medium)',
          },
          '& .MuiSlider-mark': {
            width: '2px',
            height: '6px',
            margin: '0px',
            border: 'none',
          },
          '& .MuiSlider-track': {
            height: '0px',
          },
          '& .MuiSlider-thumb': {
            height: '15px',
            width: '15px ',
            border: 'none',
            marginTop: '0px',
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          '&.MuiInputBase - input': {
            fontSize: '0.7rem !important',
            '&:after': {
              border: '1px solid #666666',
            },
          },
          '&.MuiInput-root': {
            fontSize: '0.7rem !important',
            '&:after': {
              border: '1px solid #666666',
            },
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.MuiTab-root': {
            padding: '5px 12px',
            textTransform: 'none',
            color: 'var(--color-text-primary)',
            fontSize: '0.65rem !important',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#F06423 !important',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          '&.MuiList-padding': {
            paddingTop: '5px',
            paddingBottom: '5px',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.MuiInputBase-root': {},
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          '&.MuiDialogContent-root': {
            padding: '10px 15px !important',
          },
          '&.MuiDialog-root': {
            width: '62rem',
            height: window.navigator.userAgent.includes('Safari')
              ? 'auto'
              : 'fit-content !important',
          },
          '&. MuiDialog-scrollPaper': {
            backgroundColor: 'gray',
            width: '100%',
            height: window.navigator.userAgent.includes('Safari')
              ? 'auto'
              : 'fit-content !important',
          },
          '&.MuiDialog-paper': {
            margin: '0px',
          },
        },
        paper: {
          border: '1px solid var(--color-border-medium)',
          boxShadow: '0 8px 32px var(--color-shadow)',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          border: '1px solid var(--color-border-medium)',
          boxShadow: '0 4px 16px var(--color-shadow)',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '10px 10px 10px 18px !important',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          padding: 1,
        },
        option: {
          fontSize: '0.7rem !important',
        },

      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          '& .MuiSvgIcon-root': {
            fill: 'var(--color-text-secondary)',
          },
          '& .MuiMenuItem-root:hover .MuiSvgIcon-root': {
            fill: 'var(--color-primary)',
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          '&.MuiCard-root': {
            borderColor: 'var(--color-border-light)',
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          // Style DatePicker calendar icons
          '&.MuiPickersCalendarHeader-switchViewButton, &.MuiPickersArrowSwitcher-button': {
            color: 'var(--color-link)',
          },
        }
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          // Style DatePicker calendar icon in input
          '& .MuiIconButton-root': {
            color: 'var(--color-link)',
          }
        }
      }
    }
  }
});
